import React, { memo, useCallback } from 'react';

import { Box } from '@mui/material';
import { DeleteIcon } from '@sharedCR/coreDesignSystem/icons';
import ButtonWithTooltip from 'app/shared/components/common/ButtonWithTooltip';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { FieldTypesEnum, vaServiceTypeOptions } from 'constants/loanActionEditor';
import { deleteByIndex, setIn } from 'utils/data';

import { loanManagementTestIds } from '../loanManagement.testIds';

import useFormContext from './hooks/useFormContext';
import { wrapperClassname } from './LoanActionItem.constants';
import { DynamicValueInput } from './LoanActionItems';

const LoanActionVaServiceRow = ({
  index,
  rootPath,
  isDisabled = false,
  isEditAllowed,
  isSingleItem,
}) => {
  const { form, setInForm, setValidationErrors } = useFormContext();

  const fieldPath = `${rootPath}[${index}]`;
  const serviceTypeFieldPath = `${fieldPath}.serviceType`;

  const forms = _.get(form, rootPath);

  const onDeleteRow = useCallback(() => {
    const newForms = [...forms];

    newForms.splice(index, 1);

    setInForm(rootPath, newForms);
    setValidationErrors(errors =>
      setIn(errors, rootPath, deleteByIndex(_.get(errors, rootPath, []), index)),
    );
  }, [setInForm, setValidationErrors, index, forms, rootPath]);

  return (
    <Box className={wrapperClassname}>
      <Box className="flex">
        <DynamicValueInput
          required
          className="grow"
          disabled={isDisabled || !isEditAllowed}
          label="VA Service Type"
          name={serviceTypeFieldPath}
          options={vaServiceTypeOptions}
          type={FieldTypesEnum.SELECT}
        />
        {isEditAllowed && !isSingleItem && (
          <ButtonWithTooltip
            data-testid={loanManagementTestIds.getDeleteRowButtonId(fieldPath)}
            disabled={isDisabled}
            icon={DeleteIcon}
            size="medium"
            spanContainerClassName="flex items-center"
            title="Delete row"
            onClick={onDeleteRow}
          />
        )}
      </Box>
    </Box>
  );
};

LoanActionVaServiceRow.propTypes = {
  isSingleItem: PropTypes.bool.isRequired,
  rootPath: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
};

export default memo(LoanActionVaServiceRow);
